import ButtonPopup from "../buttons/ButtonPopup.tsx";
import Popup, { IPopupRef } from "./Popup.tsx";
import { useRef } from "react";
import { AdjustmentsHorizontalIcon } from "@heroicons/react/24/outline";
import PopupItemToggle from "./PopupItemToggle.tsx";
import { useAppDispatch, useAppSelector } from "../../stores/store.ts";
import { epgPageActions } from "../epg/epgPageSlice.ts";

const EpgPageFilterPopup = () => {
    const dispatch = useAppDispatch();
    const isOpen = useAppSelector(store => store.epgPage.isFilterPopupOpen)
    const popupRef = useRef<IPopupRef>(null);
    const isAvailableInBMGOFilterOn = useAppSelector(store => store.epgPage.isAvailableInBMGOFilterOn);

    const handleOnClick = () => {
        if (isOpen && popupRef.current)
            popupRef.current.closePopup();
        else
            dispatch(epgPageActions.toggleIsFilterOpen());
    }

    const handleChangeAvailableInBMGOClick = () => {
        dispatch(epgPageActions.toggleIsAvailableInBMGOFilterOn());
    }

    return (
        <div className={"relative show-element-animation-ease-in-out"}>
            <ButtonPopup
                isOpen={isOpen}
                onClick={handleOnClick}
            >
                <AdjustmentsHorizontalIcon className="w-6 h-6" />
            </ButtonPopup>
            <Popup
                className={"-right-12 top-[2.6rem] sm:right-1/2 sm:translate-x-1/2"}
                setIsOpen={(isOpen: boolean) => dispatch(epgPageActions.setIsFilterOpen(isOpen))}
                isOpen={isOpen}
                ref={popupRef}
                title={"Wybierz dzień"}
            >
                <PopupItemToggle
                    handleChangeClick={handleChangeAvailableInBMGOClick}
                    isOn={isAvailableInBMGOFilterOn}
                    label={"Dostępne w BM GO"}
                />
            </Popup>
        </div>
    )
};

export default EpgPageFilterPopup;